module.exports = __webpack_public_path__ + "img/공팔리터_랜딩.3a142a08.png";